import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import { fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess, resetSubmitFormData } from '../common/submitForm';
import { Utils } from '../../utils/utils';
import { UNAUTHORIZED } from './../common/handleApiCall';
import { logout } from './login';

//- Actions
export const onActivateSuccess = () => (dispatch) => {
    dispatch(logout());
    dispatch(fetchSubmitFormSuccess());
};
export const onActivateAccount = createAction(
    'FETCH_ACTIVATE_ACCOUNT', 
    (token, data) => Api.activateAccount(token, data),
    () => ({
        apiCall: true,
        onSuccess: onActivateSuccess,
        onFail: onSubmitFormFailed
    })
);

export const onSubmitFormFailed = (error) => (dispatch) => {
    if (error === UNAUTHORIZED){
        dispatch(fetchSubmitFormFailed("ACTIVATION_NOT_NEEDED"));
    } else {
        dispatch(fetchSubmitFormFailed(error));
    }
};

export const fetchActivateAccount = (token, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onActivateAccount(token, data));
}

export const onGetApplicantTokenSuccess = createAction('FETCH_GET_APPLICANT_TOKEN_SUCCESS');
export const fetchGetApplicantTokenSuccess = (data) => dispatch => {
    //TODO: if we need to get role to check token type, do it by fetchGetUserDataByToken
    // if (ROLES[role] !== ROLES.APPLICANT){
    //     dispatch(fetchSubmitFormFailed("INCORRECT_ACCOUNT_TYPE"));
    // } else {
        dispatch(resetSubmitFormData());
        dispatch(onGetApplicantTokenSuccess(data.token));
    // }
}
//TODO: Api.getToken was changed! Need to refactor logic or remove unused code
export const fetchGetApplicantToken = (login, password) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onGetApplicantToken(login, password));
}
export const onGetApplicantToken = createAction(
    'FETCH_GET_APPLICANT_TOKEN',
    (login, password) => Api.getToken(login, password),
    () => ({
        apiCall: true,
        onSuccess: fetchGetApplicantTokenSuccess,
        onFail: fetchGetApplicantTokenFailed
    })
);

export const fetchGetApplicantTokenFailed = (result) => dispatch => {
    if (result === UNAUTHORIZED) {
        dispatch(fetchSubmitFormFailed("INCORRECT_USERNAME_OR_PASSWORD"));
    } else {
        dispatch(fetchSubmitFormFailed(result));
    }
}

export const onResendActivation = createAction(
    'FETCH_RESEND_ACTIVATION', 
    (email) => Api.resendActivation(email),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail: fetchSubmitFormFailed
    })
);
export const fetchResendActivation = (email) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onResendActivation(email));
}

//- State
const initialState = {
    applicantToken: null
};

//- Reducers
export default handleActions({
    FETCH_GET_APPLICANT_TOKEN: (state) => {
        return { ...state, applicantToken: null };
    },
    FETCH_GET_APPLICANT_TOKEN_SUCCESS: (state, action) => {
        return { ...state, applicantToken: action.payload };
    }

}, initialState);

//- Selectors
export const getApplicantToken = (state) => {
    return state.activation.applicantToken;
}

export const getTokenFromLocation = location => {
    let searchParams = Utils.getParamsFromLocationSearch(location.search);

    return searchParams.token;
};

export const getInvitedApplicantDataFromLocation = location => { 
    let searchParams = Utils.getParamsFromLocationSearch(location.search);

    if (searchParams && searchParams.token && searchParams.email){
        return searchParams;
    }

    return null;
};


// WEBPACK FOOTER //
// ./src/reducers/account/activation.js